import React from 'react'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab';

import { TextField } from './../../default'
import { useState } from 'react';
import { useEffect } from 'react';

function FormDropDown({ id, label, options, optionKey, fkProps, ...rest }) {

  const [value, setValue] = useState(null)

  useEffect(() => {
    if (value && !options.some(op => op.value === value.value)) {
      setValue(null)
      fkProps.setFieldValue(id, null)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options])

  return (
    <Autocomplete
      id={id}
      value={value}
      options={options}
      getOptionLabel={op => op.label || ''}
      getOptionSelected={(op, v) => v && op.value === v.value}
      onChange={(_, data) => {
        setValue(data)
        fkProps.setFieldValue(id, data ? data.value : '')
      }}
      onBlur={() => fkProps.setTouched({ ...fkProps.touched, [id]: true })}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          helperText={fkProps.touched[id] ? fkProps.errors[id] : ""}
          error={fkProps.touched[id] && Boolean(fkProps.errors[id])}          
        />
      )}
      {...rest}
    />
  )
}

FormDropDown.propsTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  optionKey: PropTypes.string,
}

FormDropDown.defaultProps = {
  optionKey: 'name'
}

export default FormDropDown